import { NgModule } from '@angular/core';
import { ContratacaoCaptacaoMainComponent } from './contracao-captacao-main/contratacao-captacao-main.component';
import { CommonModule } from '@angular/common';
import { GlobalModule } from 'src/app/global/global.module';

@NgModule({
  declarations: [ContratacaoCaptacaoMainComponent],
  imports: [CommonModule, GlobalModule],
})
export class ContratacaoCaptacaoModule {}
